import React, { useEffect, useState } from "react";
import { isPossiblePhoneNumber, parsePhoneNumber } from "libphonenumber-js";
import QRCode from "react-qr-code";

const Qr = () => {
  const [ownerName, setOwnerName] = useState("");
  const [isShow, setIsShow] = useState(false);
  const [validatePhone, setValidatePhone] = useState(false);
  const [inviteUrl, setInviteUrl] = useState("");

  const handleChangePhone = event => {
    setOwnerName(event.target.value.replace(/\D/g, ""));
  };

  const handleSubmit = event => {
    setIsShow(true);
  };

  useEffect(() => {
    var url = "https://" + window.env.DEEPLINK_HOST + "/forwardlink?";
    let phone = "";
    try {
      phone = ownerName !== "" ? parsePhoneNumber(ownerName, "VN").number : "";
      setValidatePhone(isPossiblePhoneNumber(ownerName, "VN") === true);
    } catch (e) {
      console.log(e);
      setIsShow(false);
      setValidatePhone(false);
    }

    var mobileData = {
      type: 0,
      branch_domain: window.env.BRANCH_DOMAIN,
      branch_id: window.env.BRANCH_ID,
      owner_name: phone,
      service_id: 0,
    };
    const deepLinkUrl =
      window.env.TRIOS_SCHEMA + "://" + window.env.TRIOS_SCHEMA + "?" + new URLSearchParams(mobileData).toString();
    const data = {
      type: 0,
      branch_domain: window.env.BRANCH_DOMAIN,
      branch_id: window.env.BRANCH_ID,
      owner_name: phone,
      deeplink_url: deepLinkUrl,
      service_id: 0,
    };
    const searchParams = new URLSearchParams(data);
    url += searchParams.toString();
    setInviteUrl(url);
  }, [ownerName]);

  let logo =
    "https://" +
    window.env.BRANCH_DOMAIN +
    "/dev/v1/branch/attachment/get.json?branch_id=" +
    window.env.BRANCH_ID;

  return (
    <div style={{ padding: "16px", width: "100vw", height: "100vh", display: "flex" }}>
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <div
          style={{
            width: "100%",
            backgroundImage: "linear-gradient(to bottom, #0bb3ff, #008fe8)",
            display: "flex",
            alignItems: "center",
            borderRadius: "8px 8px 0 0",
          }}
        >
          <img
            src={logo}
            alt="logo"
            style={{
              margin: "auto",
              width: 60,
              height: 60,
              borderRadius: "50%",
              border: "1px solid #cecece",
              overflow: "hidden",
              backgroundColor: "#fff",
              objectFit: "contain",
            }}
          />
        </div>

        <p>
          <strong>Bạn thân mến,</strong>
        </p>

        <div className="mb-3">
          <label className="form-label">Vui lòng nhập số điện</label>
          <input
            type="text"
            className="form-control"
            required
            value={ownerName}
            onChange={handleChangePhone}
            name="phone"
          />
        </div>

        <button className="btn btn-primary" disabled={!validatePhone} onClick={handleSubmit}>
          Xác nhận
        </button>

        <p>
          Chào mừng bạn đến với hệ thống trao đổi thông tin trực tuyến an toàn của {window.env.BRANCH_NAME}.
        </p>
        <p>
          Bạn nhận được lời mời tham gia từ quản trị viên của branch {window.env.BRANCH_NAME} trên ứng dụng Trios. Để
          bắt đầu trò chuyện với các thành viên khác trong tổ chức bạn vui lòng làm theo hướng dẫn dưới đây:
        </p>
        <p>
          <strong>Cách 1:</strong> Nhập số điện thoại và click vào link:
          {isShow && <a href={inviteUrl}> link tham gia.</a>}
        </p>
        <p>
          <strong>Cách 2:</strong> Bạn có thể thực hiện quét mã QR dưới đây để tham gia:
        </p>
        {isShow && (
          <QRCode
            size={128}
            style={{ height: "auto", maxWidth: "50%", width: "50%" }}
            value={inviteUrl}
            viewBox={`0 0 64 64`}
          />
        )}

        <p>Chúc bạn có thời gian sử dụng hệ thống hiệu quả.</p>
        <p>Trân trọng,</p>
        <p>{window.env.BRANCH_NAME}.</p>
      </div>
    </div>
  );
};

export default Qr;
